import { Dispatch } from 'react';
import { post, get } from 'communication/httpClient';
import {
  LOAD_ROLES,
  LOAD_TENDER_TYPES,
  LOAD_TENDER_VALIDATORS,
  ROLES_LOADED,
  SYNC_FAILED,
  TENDER_TYPES_LOADED,
  TENDER_VALIDATORS_LOAD_ERROR,
  TENDER_VALIDATORS_LOADED,
  TOUCH_POINT_GROUPS_LOADED,
  LOAD_TOUCH_POINT_GROUPS,
  TOUCH_POINT_GROUPS_ERROR,
} from './actionTypes';
import { IMetaDataAction, IMetaDataActions } from './types';

export const initialActionsState = {
  loadRoles: () => {},
  loadTenderTypes: () => {},
  loadCheckValidators: () => {},
  resetMessageError: () => {},
};

export const getActions = (dispatch: Dispatch<IMetaDataAction>): IMetaDataActions => ({
  loadRoles: async () => {
    dispatch({
      type: LOAD_ROLES,
    });
    const { data, error } = await post(
      `/api/roles/lookups?categoryPattern=Emerald Manager Approval`,
      {}
    );
    if (data) {
      dispatch({
        type: ROLES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadTenderTypes: async () => {
    dispatch({
      type: LOAD_TENDER_TYPES,
    });
    const { data, error } = await get('/api/tenders/types');

    if (data) {
      dispatch({
        type: TENDER_TYPES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadTouchPointGroups: async () => {
    dispatch({
      type: LOAD_TOUCH_POINT_GROUPS,
    });
    const { data, error } = await get('/api/touchpoint-groups');

    if (data) {
      dispatch({
        type: TOUCH_POINT_GROUPS_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: TOUCH_POINT_GROUPS_ERROR,
        payload: error,
      });
    }
  },
  loadCheckValidators: async () => {
    dispatch({
      type: LOAD_TENDER_VALIDATORS,
    });
    const { data, error } = await get('/api/tenders/check-validators');

    if (data) {
      dispatch({
        type: TENDER_VALIDATORS_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: TENDER_VALIDATORS_LOAD_ERROR,
        payload: error,
      });
    }
  },
});
